import { Container, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

export default function CreateFeedback() {
  const [searchParams] = useSearchParams()

  const name =
    searchParams.get('name') || searchParams.get('name') === ''
      ? `, ${searchParams.get('name')}`
      : ''
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        my: 8
      }}
    >
      <img width="150px" src="img/mp.png" alt="logo" />
      <Typography align="center" variant="h5" fontWeight={900} sx={{ mt: 4 }}>
        Thanks for your feedback{name}!
      </Typography>
      <Typography align="center" sx={{ width: 360, mt: 2, px: 4 }}>
        MatchUp will always be at hand for new projects, and wishes all the best
        to you!
      </Typography>
    </Container>
  )
}
